import ROICalculator from "@/components/ROICalculator";
import { useSeoMeta } from '@unhead/react';

export default function CalculatorPage() {
  useSeoMeta({
    title: 'Mining Career ROI Calculator | MineralJobs',
    description: 'Calculate your 5-year mining career earnings. Compare FIFO vs local roles, entry level to supervisor. Free mining salary calculator.',
    ogImage: 'https://www.mineraljobs.com/og-calculator.jpg',
    ogUrl: 'https://www.mineraljobs.com/calculator/',
    twitterCard: 'summary_large_image',
  });
  return (
    <main>
    <div className="min-h-screen pt-16" style={{ background: "#111827" }}>
      <div className="max-w-3xl mx-auto px-4 sm:px-6 py-12 text-center">
        <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full border mb-4 text-xs" style={{ borderColor: "rgba(249,115,22,0.3)", background: "rgba(249,115,22,0.08)", color: "#fb923c", fontFamily: "JetBrains Mono, monospace" }}>
          ⚙️ FREE TOOL
        </div>
        <h1 className="text-4xl sm:text-5xl font-black text-white mb-4" style={{ fontFamily: "Outfit, sans-serif" }}>
          Mining Career <span style={{ color: "#f97316" }}>ROI Calculator</span>
        </h1>
        <p className="text-gray-400 text-lg mb-2">
          How much more could you earn in mining? Use our free calculator to estimate your salary uplift and 5-year earnings potential.
        </p>
      </div>
      <ROICalculator />
    </div>
    </main>
  );
}
